import React from 'react'
import axios from 'axios';
import Stepper from '../shared/stepper.js'
import ModalError from '../shared/modal_errore.js'
import ModalBoxGenerico from '../shared/modal_box_generico.js'
import Spinner from '../shared/spinner.js'
import CustomButton from '../shared/custom_button.js'
import ToggleContainer from '../shared/toggle_container.js'
import utils from "../../modules/utils";
import { handleFaFunnel, startDigitalAssistant, trackCF } from "../../modules/datalayer";
import apiInvoker from "../../modules/apiInvoker";
import { setRicontattoCf, setFirstLoad, setModificando, setFiliali, setConsensi, setFlussoModifica, setDove, setFiliale, setOrario, setGiorno, setProdotto, start, setCF, setDatiPersonali, setRecap, setVecchioAppuntamento, setOppID, setFaFunnerTriggered } from "../../actions/index";
import { connect } from 'react-redux';
import './quando.css'
// Flow
import { handleFlow, skipScegliLuogo, skipDataAppuntamento, enterInSpecificFlow } from '../../flow/flow.js';

const mapDispatchToProps = dispatch => {
  return {
    setProdotto: (type) => dispatch(setProdotto(type)),
    start: () => dispatch(start()),
    setCF: (cf) => dispatch(setCF(cf)),
    setDatiPersonali: (dati) => dispatch(setDatiPersonali(dati)),
    setRecap: (r) => dispatch(setRecap(r)),
    setVecchioAppuntamento: (v) => dispatch(setVecchioAppuntamento(v)),
    setOppID: (o) => dispatch(setOppID(o)),
    setGiorno: (giorno) => dispatch(setGiorno(giorno)),
    setOrario: (orario) => dispatch(setOrario(orario)),
    setFiliale: (filiale) => dispatch(setFiliale(filiale)),
    setDove: (location) => dispatch(setDove(location)),
    setFlussoModifica: (fl) => dispatch(setFlussoModifica(fl)),
    setConsensi: (cs) => dispatch(setConsensi(cs)),
    setFiliali: (csfili) => dispatch(setFiliali(csfili)),
    setModificando: (m) => dispatch(setModificando(m)),
    setFirstLoad: (fl) => dispatch(setFirstLoad(fl)),
    setFaFunnerTriggered: (boolean) => dispatch(setFaFunnerTriggered(boolean)),
    setRicontattoCf: (boolean) => dispatch(setRicontattoCf,(boolean)),
  }
}

class Quando extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      appuntamentoNonTrovatoVisibile: false,
      errors: '',
      loading: false
    }
    this.closeModalGenerica = this.closeModalGenerica.bind(this);
    this.handleProduct = this.handleProduct.bind(this);
    this.userDataExists = this.userDataExists.bind(this);
    this.retrieveUserData = this.retrieveUserData.bind(this);
    this.retrieveOldAppointment = this.retrieveOldAppointment.bind(this);
  }

  async componentDidMount() {
    const id_filiale = utils.getUrlParameter('id_filiale');
    if (id_filiale) {
      this.setState({
        'loading': true
      })
    }
    const composer = utils.getUrlParameter('composer');
    if (composer) {
      window.document.body.classList.add('abtestfiscale');
    }
    startDigitalAssistant(); //Ripristino il DA in caso di back
    apiInvoker.Ping()
    //axios.get('./api/Filiali/ping').then(function () { console.log("Pingato") })
    // this.props.start();
    this.props.setFirstLoad();

    utils.animate.fadeIn();
    utils.animate.slideIn();
  }

  componentDidUpdate() {
    if (this.state.isOpen === true) {
      window.$('html,body').animate({
        scrollTop: (window.$(".toggle-container").offset().top + window.$(".toggle-container").height() / 2) - 300
      })
    } else {
      window.$('html,body').animate({
        scrollTop: 0
      })
    }
  }

  handleToggle = () => {
    if (!(this.state.isOpen)) {
      this.setState({ isOpen: true });
    }
  }

  userDataExists(appointment) {
    const {utente} = appointment;

    if (utente) {
      const valuesList = Object.values(utente);

      for (let value in valuesList) {
        if (value) {
          return true;
        }
      }
    }

    return false;
  }

  retrieveUserData(appointment) {
    const { utente } = appointment;

    if (utente) {
      this.props.setDatiPersonali({
        nome: utente.nome,
        cognome: utente.cognome,
        email: utente.email,
        telefono: utente.telefono,
        cap:
          utente.cap && utente.cap != ""
            ? utente.cap
            : "99999",
        impiego: utente.impiego
      });

      if (utente.consensi) {
        this.props.setConsensi({
          informativa: utente.consensi.informativa,
          dati_personali: utente.consensi.dati_personali,
          societa_terze: utente.consensi.societa_terze,
        });
      }
    }
  }

  retrieveOldAppointment(appointment) {
    const { oppID, prodotto, luogo, coordinate_luogo: coordinateLuogo, data_appuntamento: dataAppuntamento, orario_appuntamento: orarioAppuntamento, filiale, id_filiale: idFiliale, indirizzoFiliale } = appointment;
    
    this.props.setVecchioAppuntamento(appointment);
    this.props.setOppID(oppID);
    this.props.setFlussoModifica(true);

    this.props.setRecap(true);
    this.props.setProdotto(prodotto);
    this.props.setDove({
      luogo: luogo,
      coordinate_luogo: coordinateLuogo
    });
    this.props.setGiorno(utils.setDateFormat(dataAppuntamento));
    this.props.setOrario(orarioAppuntamento);
    this.props.setFiliale({
      id: utils.padLeft3(idFiliale),
      nome: filiale,
      indirizzo: indirizzoFiliale
    });
  }

  handleSubmit = (event) => {
    event.preventDefault();
    let self = this;
    if (validateForm(event.target)) { //Se tutti i campi del form sono validi
      const cf = event.target.codice_fiscale.value;
      trackCF(cf);
      self.setState({ 'errors': '' });

      this.setState({
        'loading': true
      })
      apiInvoker.CheckByCF(
        cf,
        "modifica_appuntamento",
        (res) => {
          if (res.status == 200) {
            const { data: responseBody } = res;
            let { trackingUrl, appuntamento } = responseBody;

            if (responseBody.status == 200) {
              if (trackingUrl) {
                axios.get(trackingUrl);
              }
              if (responseBody.hasOwnProperty('ricontatto') && responseBody.ricontatto == true) {
                self.props.setRicontattoCf(responseBody.ricontatto);
              }
              if (!appuntamento.oppID) {
                apiInvoker.CheckCFC5(cf, res => {
                  const { data: responseBody } = res;
                  let { appuntamento } = responseBody;

                  if (!appuntamento.oppID) {
                    self.setState({
                      loading: false,
                      appuntamentoNonTrovatoVisibile: true,
                    });
                  } else {
                    if (appuntamento && appuntamento.utente) {
                      appuntamento.utente = utils.getFinalUserData(appuntamento.utente);
                    }

                    self.retrieveUserData(appuntamento);
                    self.retrieveOldAppointment(appuntamento);

                    this.props.setCF(cf);

                    self.setState({
                      loading: false,
                    });

                    handleFlow();
                  }
                }, err => {
                  this.setState({
                    loading: false,
                  });
                  document.querySelector(".modal-error .error-text").innerText = err;
                  document
                    .querySelector(".modal-error-container")
                    .classList.add("is-modal-shown");
                })
              } else {
                
                //TODO: check if correct
                /*
                if (appuntamento && appuntamento.utente) {
                  appuntamento.utente = utils.getFinalUserData(appuntamento.utente);
                }
                */

                self.retrieveUserData(appuntamento);
                self.retrieveOldAppointment(appuntamento);

                this.props.setCF(cf);

                self.setState({
                  loading: false,
                });

                handleFlow();
              }
            } else if (responseBody.status == 400) {
              document.querySelector(".modal-error .error-text").innerText =
              responseBody.message;
              document
                .querySelector(".modal-error-container")
                .classList.add("is-modal-shown");
            }
          }
        },
        (err) => {
          this.setState({
            loading: false,
          });
          document.querySelector(".modal-error .error-text").innerText = err;
          document
            .querySelector(".modal-error-container")
            .classList.add("is-modal-shown");
        }
      );
      
    } else {
      self.setState({ 'errors': 'Codice fiscale non valido' });
    }
  }

  closeModalGenerica() {
    this.setState({
      isOpen: false,
      appuntamentoNonTrovatoVisibile: false
    })
  }

  handleProduct(product) {
    switch (product) {
      case 1:
        handleFaFunnel('Prestito personale');
        break;
      case 3:
        handleFaFunnel('Cessione del quinto');
        // skipScegliLuogo();
        // skipDataAppuntamento();
        break;
      case 4:
        handleFaFunnel('Carta di credito');
        break;
      case 5:
        handleFaFunnel('Prestito business');
        skipScegliLuogo();
        skipDataAppuntamento();
        break;
      default:
    }

    this.props.setFaFunnerTriggered(true);

    enterInSpecificFlow(product);
  }

  render() {
    return (
      <div>
        <Stepper percentage="20" />
        <ModalError />
        <ModalBoxGenerico handler={this.closeModalGenerica} testo="Non hai nessun appuntamento in programma" visible={this.state.appuntamentoNonTrovatoVisibile} buttontext="FISSA APPUNTAMENTO" />
        <Spinner visible={this.state.loading} />
        <div className="grid-container" id="quando">
          <div className="grid-x grid-padding-x">
            <div className="cell animations-container">
              <h2 className="gsap-fade">Ciao, a cosa sei interessato?</h2>
              <div id="button_area">
                {/*<CustomButton value="Il prima possibile" handler={() => this.handleType('fast')} />
                                <CustomButton value="Scegli data e ora" handler={() => this.handleType('standard')} />*/}
                <CustomButton value="Prestito personale" description="Per il tuo prestito, basta un giorno." handler={() => this.handleProduct(1)} />
                <CustomButton value="Cessione del quinto" description="Fino a 75.000 € per i tuoi progetti." handler={() => this.handleProduct(3)} />
                <CustomButton value="Carta di credito" description="Fido a partire da 1.500 €." handler={() => this.handleProduct(4)} />
                <CustomButton value="Prestito Business" description="Fino a 50.000 € per la tua attività." handler={() => this.handleProduct(5)} />
                <p className="section-title gsap-slide">
                  Hai già fissato un appuntamento e vuoi spostarlo?
                </p>
                <ToggleContainer title="Modifica appuntamento" type="codice fiscale" isOpen={this.state.isOpen} handleToggle={this.handleToggle} handleSubmit={this.handleSubmit} errors={this.state.errors} />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

function validateForm(form) {
  const cf = form.codice_fiscale.value;
  let valid_cf = utils.validateCF(cf);
  return valid_cf;
}

export default connect(null, mapDispatchToProps)(Quando);


// WEBPACK FOOTER //
// ./src/components/quando/index.js